import { useTheme } from '../../context/ThemeContext';

const Tab = ({ tabs, active, onChange }) => {
  const { dark } = useTheme();
  return (
    <div style={{ display: 'flex', gap: 2, borderBottom: `1px solid ${dark ? '#334155' : '#E2E8F0'}`, marginBottom: 20 }}>
      {tabs.map(t => (
        <button key={t.key} onClick={() => onChange(t.key)} style={{
          padding: '10px 18px', fontSize: 13, cursor: 'pointer',
          background: 'none', border: 'none',
          fontWeight: active === t.key ? 600 : 500,
          borderBottom: `2px solid ${active === t.key ? '#3B82F6' : 'transparent'}`,
          color: active === t.key ? (dark ? '#F1F5F9' : '#0F172A') : (dark ? '#64748B' : '#94A3B8'),
          transition: 'all 0.15s',
        }}>
          {t.label}
          {t.count !== undefined && (
            <span style={{
              marginLeft: 6, fontSize: 11, fontWeight: 600,
              padding: '1px 6px', borderRadius: 10,
              background: active === t.key ? '#3B82F6' : (dark ? '#334155' : '#E2E8F0'),
              color: active === t.key ? '#fff' : (dark ? '#94A3B8' : '#64748B'),
            }}>
              {t.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default Tab;
